import { render } from "./Chartcuentas.vue?vue&type=template&id=6afbd2b2"
import script from "./Chartcuentas.vue?vue&type=script&lang=js"
export * from "./Chartcuentas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__